
import httpClient from "@/plugins/axios";

export const getFeedbacks = async () => {
    const response = await httpClient.get("/v2/feedbacks/?admin_view=1");
    return response;
}

export const getFeedback = async (id) => {
    const response = await httpClient.get(`/v1/feedback/${id}/?admin_view=1`);
    return response;
}

export const saveFeedbackMessage = async (id, message) => {
    const response = await httpClient.post(`/v1/feedback/${id}/messages?admin_view=1`, {
        text: message
    });
    return response;
}

export const updateFeedback = async (feedback) => {
    const response = await httpClient.put(`/v1/feedback/${feedback.id}/?admin_view=1`, feedback);
    return response;
}

export const getFeedbackCount = async (status) => {
    const response = await httpClient.get(`/v1/feedbacks/count?status=${status}`);
    return response;
}

export const downloadLegacyFeedbackAttachment = async (feedbackId) => {
    const response = await httpClient.get(`/v1/feedback/${feedbackId}/attachment?admin_view=1`,
        {
            responseType: 'blob',
        });

    return response;
}

export const downloadFeedbackAttachment = async (feedbackId, attachmentId) => {
    const response = await httpClient.get(`/v2/feedback/${feedbackId}/attachments/${attachmentId}/`,
        {
            responseType: 'blob',
        });

    return response;
}

export const getFeedbackManagers = async () => {
    const response = await httpClient.get(`/v1/settings/feedback-managers/`);
    return response;
}

export const addFeedbackManager = async (manager) => {
    const response = await httpClient.post(`/v1/settings/feedback-managers/`, manager);

    return response;
}

export const updateFeedbackManager = async (manager) => {
    const response = await httpClient.put(`/v1/settings/feedback-managers/${manager.user}/`, manager);

    return response;
}

export const removeFeedbackManager = async (managerId) => {
    const response = await httpClient.delete(`/v1/settings/feedback-managers/${managerId}/`);
    return response;
}

export const getFeedbackManagerLog = async () => {
    const response = await httpClient.get(`/v1/settings/feedback-managers/log/`);
    return response;
}

export const getFeedbackCategories = async () => {
    const response = await httpClient.get(`/admin/v1/feedback/categories/`);
    return response;
}

export const getFeedbackCategory = async (id) => {
    const response = await httpClient.get(`/admin/v1/feedback/categories/${id}/`);
    return response;
}

export const saveFeedbackCategory = async (category) => {
    if (category.id) {
        const response = await httpClient.put(`/admin/v1/feedback/categories/${category.id}/`, category);
        return response;
    }
    else {
        const response = await httpClient.post(`/admin/v1/feedback/categories/`, category);
        return response;
    }
}